module.exports = __webpack_public_path__ + "img/ucenter-default-avator.0b9638e3.png";